var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIconLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.915,
    height: 10.915,
    viewBox: "0 0 10.915 10.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross-icon-light",
    transform: "translate(-639.07 -2076.194) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_230",
    "data-name": "Line 230",
    d: "M-.082,13.2A.718.718,0,0,1-.8,12.482V-.082A.718.718,0,0,1-.082-.8a.718.718,0,0,1,.718.718V12.482A.718.718,0,0,1-.082,13.2Z",
    transform: "translate(1927.782 1010)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231",
    "data-name": "Line 231",
    d: "M12.482.636H-.082A.718.718,0,0,1-.8-.082.718.718,0,0,1-.082-.8H12.482a.718.718,0,0,1,.718.718A.718.718,0,0,1,12.482.636Z",
    transform: "translate(1921.5 1016.282)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconLight);
export default __webpack_public_path__ + "static/media/cross-icon-light.80aec30dd15d23550e4c44225d95e709.svg";
export { ForwardRef as ReactComponent };